/**************************************************
 * Nombre:       Dashboard
 * Descripcion:
 *
 * Libreria:
 *
 * Tiempo:     1 Hr
 **************************************************/
import {Button, Grid} from "@mui/material";
import DashboardBase from "../Modulo_Dashboard/Componentes/DashboardBase";
import React, {createContext, useContext, useEffect, useState} from "react";
import {
    AccountTreeOutlined,
    BadgeOutlined,
    CampaignOutlined,
    CheckroomOutlined,
    DashboardOutlined,
    GirlOutlined,
    LocalOfferOutlined,
    PeopleOutlined,
    SettingsOutlined,
    ShoppingCartOutlined
} from "@mui/icons-material";
import {funSalir} from "../Servicios/Auth/funSalir";
import {usuarioContext} from "../App";
import Seccion_Colecciones from "./Secciones/Seccion_Colecciones";
import Seccion_Productos from "./Secciones/Seccion_Productos";
import Seccion_Configuraciones from "./Secciones/Seccion_Configuraciones";
import Seccion_Pedidos from "./Secciones/Seccion_Pedidos";
import Seccion_Usuarios from "./Secciones/Seccion_Usuarios";
import Seccion_SubCategorias from "./Secciones/Seccion_SubCategorias";
import Seccion_Suscriptores from "./Secciones/Seccion_Suscriptores";
import Seccion_Etiquetas from "./Secciones/Seccion_Etiquetas";
import {obtenerCol} from "../Servicios/BD/obtenerCol";
import {descargarJSON} from "../Modulo_Trasteo/descargarJson";
import data from '../Modulo_Trasteo/data.json'
import {guardarDoc} from "../Servicios/BD/guardarDoc";
import Seccion_Anuncios from "./Secciones/Seccion_Anuncios";
import Seccion_Looks from "./Secciones/Seccion_Looks";


export const contexBarra = createContext()
const Dashboard = () => {
    const [notificaciones, setNotificaciones] = useState([])
    const [nuevasNotificaciones, setNuevasNotificaciones] = useState(0)
    const [historial, setHistorial] = useState([])
    const [nuevoHistorial, setNuevoHistorial] = useState(0)
    const {usuario} = useContext(usuarioContext)
    const [cargando, setCargando] = useState(false)

    const [open, setOpen] = useState(false)
    const salir = () => {
        funSalir()
    }

    const valoresBarra = {
        notificaciones,
        nuevasNotificaciones,
        historial,
        nuevoHistorial,
        funSalir: salir

    }


    const {Provider} = contexBarra;

    const traer = async () => {

        let doxCol = await obtenerCol('productos')
        let prods = doxCol.data
        //  console.log(prods)
        descargarJSON(prods)

    }

    const convertir = async () => {
        setCargando(true)
        let arr = data
        for (let i = 0; i < arr.length; i++) {
            let prod = arr[i]

            if (prod.descripcion) {
                prod.informaciones = [
                    {
                        nombre: 'Descripción',
                        descripcion: prod.descripcion
                    }
                ]
            }

            let dox = await guardarDoc('productos', prod)


        }

        setCargando(false)
    }


    useEffect(() => {


    }, [usuario]);
    return (
        <Grid
            container
            size={12}
        >


            <Provider value={valoresBarra}>
                <DashboardBase secciones={secciones} seccionesPerfil={seccionesPerfil} seccionesID={seccionesID}/>
            </Provider>

            {/*<Grid container size={{xs: 12, sm: 12, md: 12}} sx={{justifyContent: 'flex-end', p: 8}}>
                <Button
                    loading={cargando}
                    onClick={() => convertir()}
                >Trastero</Button>
            </Grid>*/}

        </Grid>
    )

}
export default Dashboard

const secciones = [


    {
        nombre: 'Pedidos',
        icono: ShoppingCartOutlined,
        camino: '/Pedidos',
        categoria: 'Tienda',
        Componente: <Seccion_Pedidos/>
    },
    {
        nombre: 'Colecciones',
        icono: DashboardOutlined,
        camino: '/Colecciones',
        categoria: 'Tienda',
        Componente: <Seccion_Colecciones/>
    },
    {
        nombre: 'Prendas',
        icono: CheckroomOutlined,
        camino: '/Prendas',
        categoria: 'Tienda',
        Componente: <Seccion_Productos/>
    },
    {
        nombre: 'Looks',
        icono: GirlOutlined,
        camino: '/Looks',
        categoria: 'Tienda',
        Componente: <Seccion_Looks/>
    },

    {
        nombre: 'Suscriptores',
        icono: PeopleOutlined,
        camino: '/Suscriptores',
        categoria: 'Tienda',
        Componente: <Seccion_Suscriptores/>
    },
    {
        nombre: 'Anuncios',
        icono: CampaignOutlined,
        camino: '/Anuncios',
        categoria: 'Configuraciones',
        Componente: <Seccion_Anuncios/>
    },
    {
        nombre: 'Etiquetas',
        icono: LocalOfferOutlined,
        camino: '/Etiquetas',
        categoria: 'Configuraciones',
        Componente: <Seccion_Etiquetas/>
    },
    {
        nombre: 'SubCategorias',
        icono: AccountTreeOutlined,
        camino: '/SubCategorias',
        categoria: 'Configuraciones',
        Componente: <Seccion_SubCategorias/>
    },
    {
        nombre: 'Generales',
        icono: SettingsOutlined,
        camino: '/Generales',
        categoria: 'Configuraciones',
        Componente: <Seccion_Configuraciones/>
    },
    {
        nombre: 'Usuarios',
        icono: BadgeOutlined,
        camino: '/Usuarios',
        categoria: 'Configuraciones',
        privada: true,
        Componente: <Seccion_Usuarios/>
    }
]

const seccionesID = []

const seccionesPerfil = []

const notificaciones = {}